import React from 'react'
import UnderConstruction from '../../components/underConstruction/UnderConstruction'

function Vehicles() {
    return (
        <UnderConstruction/>
    )
}

export default Vehicles
